import { createRootRoute, Outlet, useMatchRoute } from "@tanstack/react-router";
import Navbar from "@/features/home/Navbar";
import ScrollToTop from "react-scroll-to-top";
import NotFound from "@/features/not-found/page";
import { useDarkMode } from "@/hooks/useDarkMode";

export const Route = createRootRoute({
  component: () => {
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const isDark = useDarkMode();
    // eslint-disable-next-line react-hooks/rules-of-hooks
    const matchRoute = useMatchRoute();

    // Determine if the current route matches '/mysavedplaces'
    const isMySavedPlacesActive =
      matchRoute({ to: "/savedplacedetails/$savedPlaceId/user/$userId" });

    // Determine if the current route matches '/'
    const isMapActive =
      matchRoute({ to: "/" });

    return (
      <div
        className={`h-screen ${isMySavedPlacesActive ? "overflow-hidden" : ""}`}
      >
        <Navbar />
        <Outlet />
        {!isMapActive && (
          <ScrollToTop
            smooth
            component={
              <img 
                src={isDark ? "/images/BackToTop_Dark.svg" : "/images/BackToTop_Light.svg"} 
                alt="Scroll to top" 
              />
            }
          />
        )}
      </div>
    );
  },
  notFoundComponent: notFoundComponent,
});

function notFoundComponent() {
  return <NotFound />;
}
